import { SIZES } from "@frontend/styles/constants";

export const ICON_TAG_NAME = "icon" as const;

export const ICON_SIZES: Record<(typeof SIZES)[number], number> = {
  sm: 14,
  md: 16,
  lg: 18,
};
